import React from 'react';
import { thumbnailOverlayPropTypes } from '../propTypes';
import { THUMBNAIL_OVERLAY_COLOR } from '../constants';

const ThumbnailOverlay = ({
  icon: Icon,
  iconProps = {},
  className = '',
  style = {}
}) => (
  <span
    className={
      `sui-absolute sui-inset-0 sui-flex sui-items-center sui-justify-center sui-text-inverse ${
        className || ''
      }`
    }
    style={{
      backgroundColor: THUMBNAIL_OVERLAY_COLOR,
      ...style
    }}
  >
    <Icon color="current" {...iconProps} />
  </span>
);

ThumbnailOverlay.propTypes = thumbnailOverlayPropTypes;

export default ThumbnailOverlay;
